import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "cell shrink bg-bg" }
const _hoisted_2 = { class: "cell shrink" }
const _hoisted_3 = {
  key: 0,
  class: "text-center p-4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "mr-4" }, "loading...", -1 /* HOISTED */)
const _hoisted_5 = {
  key: 0,
  class: "cell shrink"
}
const _hoisted_6 = {
  class: "cell auto",
  ref: "table_container"
}
const _hoisted_7 = { class: "full_height_container grid-y" }
const _hoisted_8 = { class: "cell shrink" }
const _hoisted_9 = { class: "grid-x m-1" }
const _hoisted_10 = { class: "cell shrink" }
const _hoisted_11 = { class: "cell shrink" }
const _hoisted_12 = { class: "text-sm pt-1 ml-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "point", -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "vertex", -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "primitive", -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "object", -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "container", -1 /* HOISTED */)
const _hoisted_18 = { class: "cell auto" }
const _hoisted_19 = {
  ref: "gridElement",
  class: "ag-theme-balham-dark"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationWithLinkedIndex = _resolveComponent("NavigationWithLinkedIndex")!
  const _component_ArrowPathIcon = _resolveComponent("ArrowPathIcon")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_AttributesSelectInput = _resolveComponent("AttributesSelectInput")!
  const _component_SolidCubeIcon = _resolveComponent("SolidCubeIcon")!
  const _component_ShareIcon = _resolveComponent("ShareIcon")!
  const _component_MapIcon = _resolveComponent("MapIcon")!
  const _component_CubeIcon = _resolveComponent("CubeIcon")!
  const _component_CircleStackIcon = _resolveComponent("CircleStackIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" TODO: vue3: add spinner and checked back "),
    _createElementVNode("div", {
      class: "Panel Spreadsheet full_height_container grid-y bg-bg-medium",
      onPointermove: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.on_pointer_move && _ctx.on_pointer_move(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NavigationWithLinkedIndex, {
          linkIndex: _ctx.linkIndex,
          onLinkIndexUpdate: _ctx.onLinkIndexUpdate
        }, null, 8 /* PROPS */, ["linkIndex", "onLinkIndexUpdate"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_ArrowPathIcon, { class: "h-4 animate-spin inline" })
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      (!_ctx.firstSelectedNodeIsSpreadsheetable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_EmptyState, {
              title: "No SOP node selected",
              subtitle: "Select any SOP node to display its attributes here"
            })
          ]))
        : _createCommentVNode("v-if", true),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_AttributesSelectInput, {
                  class: "mr-1",
                  displayedLabel: _ctx.attributesSelectInputDisplayedName,
                  entries: _ctx.attributesSelectEntries,
                  onToggleAttribute: _ctx.attributesSelectInputToggleAttribute,
                  onSelectNone: _ctx.attributesSelectInputSelectNone,
                  onSelectAll: _ctx.attributesSelectInputSelectAll
                }, null, 8 /* PROPS */, ["displayedLabel", "entries", "onToggleAttribute", "onSelectNone", "onSelectAll"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["border border-gray-600 rounded-l-md inline px-2 py-1 select-none cursor-pointer hover:bg-gray-700", _ctx.classObjectPointButton]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setAttribClassPoint())),
                    title: "vertices"
                  }, [
                    _createVNode(_component_SolidCubeIcon, { class: "h-4 w-4 inline" }),
                    _hoisted_13
                  ], 2 /* CLASS */),
                  _createElementVNode("div", {
                    class: _normalizeClass(["border border-gray-600 inline px-2 py-1 select-none cursor-pointer hover:bg-gray-700", _ctx.classObjectVertexButton]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setAttribClassVertex())),
                    title: "vertices"
                  }, [
                    _createVNode(_component_ShareIcon, { class: "h-4 w-4 inline" }),
                    _hoisted_14
                  ], 2 /* CLASS */),
                  _createElementVNode("div", {
                    class: _normalizeClass(["border border-gray-600 inline px-2 py-1 select-none cursor-pointer hover:bg-gray-700", _ctx.classObjectPrimitiveButton]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setAttribClassPrimitive())),
                    title: "vertices"
                  }, [
                    _createVNode(_component_MapIcon, { class: "h-4 w-4 inline" }),
                    _hoisted_15
                  ], 2 /* CLASS */),
                  _createElementVNode("div", {
                    class: _normalizeClass(["border border-gray-600 inline px-2 py-1 select-none cursor-pointer hover:bg-gray-700", _ctx.classObjectObjectButton]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setAttribClassObject())),
                    title: "objects"
                  }, [
                    _createVNode(_component_CubeIcon, { class: "h-4 w-4 inline" }),
                    _hoisted_16
                  ], 2 /* CLASS */),
                  _createElementVNode("div", {
                    class: _normalizeClass(["border border-gray-600 rounded-r-md inline px-2 py-1 select-none cursor-pointer hover:bg-gray-700", _ctx.classObjectCoreGroupButton]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setAttribClassCoreGroup())),
                    title: "coreGroup"
                  }, [
                    _createVNode(_component_CircleStackIcon, { class: "h-4 w-4 inline" }),
                    _hoisted_17
                  ], 2 /* CLASS */)
                ])
              ]),
              _createCommentVNode(" <SelectInputWithSubtitles\n\t\t\t\t\t\t\t:entries=\"AttribClassMenuEntries\"\n\t\t\t\t\t\t\t:value=\"selected_attrib_class\"\n\t\t\t\t\t\t\t@change=\"onSelectAttribClassChange\"\n\t\t\t\t\t\t></SelectInputWithSubtitles> ")
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, null, 512 /* NEED_PATCH */),
            _createCommentVNode(" <ag-grid-vue\n\t\t\t\t\t\t\tstyle=\"width: 500px; height: 200px\"\n\t\t\t\t\t\t\tclass=\"ag-theme-alpine\"\n\t\t\t\t\t\t\t:columnDefs=\"columnDefs\"\n\t\t\t\t\t\t\t:rowData=\"rowData\"\n\t\t\t\t\t\t></ag-grid-vue> ")
          ])
        ])
      ], 512 /* NEED_PATCH */), [
        [_vShow, _ctx.displayTable]
      ])
    ], 32 /* HYDRATE_EVENTS */),
    _createCommentVNode(" //- .Panel.Spreadsheet.full_height_container.grid-y(@pointermove = 'on_pointer_move') //- .cell.shrink //-\n\tNavigationWithLinkedIndex(:linkIndex='linkIndex' @linkIndexUpdate='onLinkIndexUpdate') //- .cell.shrink //-\n\tspan(v-if='loading') //- +spinner //- span loading... //-\n\t.no-node-selected(v-if='!firstSelectedNodeIsSpreadsheetable') no SOP node selected //- .cell.auto( //- v-if =\n\t'displayTable' //- ref = 'table_container' //- ) //- .full_height_container.grid-y //- .cell.shrink //- .grid-x //-\n\t.cell.shrink //- .spreadsheet-drop-down-container //- .spreadsheet-drop-down-label view attributes //-\n\t.spreadsheet-drop-down-content //- .spreadsheet-drop-down-entry(@click = 'select_all_attributes') //-\n\tspan.attr-selection-icon //- +checked('true') //- span.attr-name select all //- .spreadsheet-drop-down-entry(@click\n\t= 'select_no_attributes') //- span.attr-selection-icon //- +checked('false') //- span.attr-name select none //-\n\t.spreadsheet-drop-down-separator //- .spreadsheet-drop-down-entry( //- v-for = 'attrib_name in attrib_names' //-\n\t@click = 'toggle_attrib_selection(attrib_name)' //- ) //- span.attr-selection-icon //-\n\t+checked('attrib_selected_states[attrib_name]') //- span.attr-name {{ attrib_name }}\n\t//- .cell.shrink //- .attrib-class-selectors //- .attrib-class-selector( //- @click = 'set_attrib_class_object()'\n\t//- title = 'objects' //- :class = 'class_object_object_button' //- ) //- v-icon(name = 'square') //- span objects\n\t//- .attrib-class-selector( //- @click = 'set_attrib_class_point()' //- title = 'vertices' //- :class =\n\t'class_object_point_button' //- ) //- v-icon(name = 'regular/circle') //- span points //- .cell.auto //-\n\tag-grid-vue( //- class = \"ag-theme-balham\" //- :rowData = \"table_data\" //- :columnDefs = \"columnDefs\" //- :modules =\n\t'modules' //- :defaultColDef = \"defaultColDef\" //- :columnTypes = 'columnTypes' //- :getRowClass = 'getRowClass' //-\n\t) ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}